import { getLogger } from "loglevel";
import { AnalyticsImpl } from "~/modules/analytics/AnalyticsImpl";
import { CbmImpl } from "~/modules/cbm";
import { LoggerName } from "~/modules/logger";
import { TaskRouterImpl } from "~/packages/taskrouter/TaskRouterImpl";
import { getReservationsByTask, sendTrackingEvent, getDefaultCallerID } from "~/modules/actions/ActionUtils";
import { EVENTS } from "~/modules/analytics/Analytics";
import { ContextManager } from "~/modules/contextManager/ContextManager";
import { FlexSdkError, ErrorCode, ErrorSeverity } from "~/modules/error";
import { AddVoiceParticipantResponse, ParticipantType } from "~/packages/cbm";
import { AccountConfigDataContainer } from "~/modules/config/AccountConfig/AccountConfigImpl/AccountConfigDataContainer/AccountConfigDataContainer";
import { Action } from "~/modules/actions/Action";




















export class StartExternalWarmVoiceTaskTransfer implements Action<Promise<AddVoiceParticipantResponse>> {
    


    #taskSid: string;

    


    #phoneNumber: string;

    


    #callerId?: string;

    constructor(taskSid: string, phoneNumber: string, callerId?: string) {
        this.#taskSid = taskSid;
        this.#phoneNumber = phoneNumber;
        this.#callerId = callerId;
    }

    async run(ctx: {}) {
        const context = ctx as ContextManager;
        const taskRouter = context.getInstanceOf(TaskRouterImpl);
        const logger = getLogger(LoggerName.Actions);
        const worker = taskRouter.worker;
        const analytics = context.getInstanceOf(AnalyticsImpl);
        const cbm = context.getInstanceOf(CbmImpl);
        const accountConfig = context.getInstanceOf(AccountConfigDataContainer);

        logger.debug(
            `startExternalWarmVoiceTaskTransfer invoked with #taskSid: ${this.#taskSid} and #phoneNumber: ${
                this.#phoneNumber
            }`
        );

        if (!worker) {
            const errorMsg = "startExternalWarmVoiceTaskTransfer: worker is not initialized";
            logger.error(errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const reservations = getReservationsByTask(worker, this.#taskSid);
        const reservation = reservations.find((res) => res.status === "accepted");

        if (!reservation) {
            const errorMsg = `startExternalWarmVoiceTaskTransfer: Reservation for task ${this.#taskSid} is not found`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.StartExternalWarmVoiceTaskTransferCompleted, analytics, worker, errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        const callerIdParam = this.#callerId || getDefaultCallerID(accountConfig.get().outboundCallFlows);
        if (!callerIdParam) {
            const errorMsg = `startExternalWarmVoiceTaskTransfer: #callerId not found`;
            logger.error(errorMsg);
            sendTrackingEvent(EVENTS.StartExternalWarmVoiceTaskTransferCompleted, analytics, worker, errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }

        try {
            return await cbm.addVoiceParticipant(reservation.task, {
                from: callerIdParam,
                to: this.#phoneNumber,
                type: "external" as ParticipantType
            });
        } catch (error) {
            const errorMsg = `startExternalWarmVoiceTaskTransfer: Could not transfer task: ${error.message}`;
            sendTrackingEvent(EVENTS.StartExternalWarmVoiceTaskTransferCompleted, analytics, worker, errorMsg);
            return Promise.reject(new FlexSdkError(ErrorCode.SDK, { severity: ErrorSeverity.Error }, errorMsg));
        }
    }
}
